import { ChangeEvent } from 'react'
import Image from '@/components/image'
import { InputFieldSearch } from '@/components/input'
import { H1 } from '@/components/typography'
import { useSmallScreen } from '@/hooks/useMediaQuery'
import { TeamOverview } from '@/interfaces/schema'
import Block from '@/layouts/block'
import Section from '@/layouts/section'
import { GRID } from '@/lib/constants'

type OurTeamHeaderProps = Pick<TeamOverview, 'icon' | 'title'> & {
  handleInputSearchQueryChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const OurTeamHeader = ({
  icon,
  title,
  handleInputSearchQueryChange,
}: OurTeamHeaderProps) => {
  const isSmallScreen = useSmallScreen()

  return (
    <Section className={`${GRID} ourTeamHeader`}>
      <Block className="ourTeamHeader__iconTitle">
        {icon && (
          <Image
            src={icon?.url ?? ''}
            height={isSmallScreen ? 30 : 40}
            width={isSmallScreen ? 18 : 30}
            objectFit="contain"
            alt=""
            className="w-[30px] md:w-[70px]"
          />
        )}
        <H1>{title}</H1>
      </Block>
      <InputFieldSearch
        wrapperClassName="ourTeamHeader__searchBar"
        onChange={handleInputSearchQueryChange}
        name=""
        placeholder="Zoek een medewerker..."
        loading={false}
      />
    </Section>
  )
}

export default OurTeamHeader
